<template>
    <Tabs
        :tabs="tabs"
        :selectedTabKey="selectedTab"
    />
</template>

<script setup lang="ts">
    import type { TabItemInterface } from '@/Shared/Component/Tabs.vue'
    import Tabs from '@/Shared/Component/Tabs.vue'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import { MeetingTabKeyEnum } from '@/Shared/AutoGenerated/Types'
    import type { PropType } from 'vue'

    const props = defineProps({
        selectedTab: {
            type: String as PropType<MeetingTabKeyEnum>,
            required: true,
        },
    })

    const tabs: TabItemInterface[] = [
        {
            key: MeetingTabKeyEnum.Meeting,
            title: 'Meetings',
            url: RoutePathAppEnum.Meetings,
            iconName: null,
            iconClass: null,
        },
        {
            key: MeetingTabKeyEnum.Recurring,
            title: 'Recurring',
            url: RoutePathAppEnum.Recurring,
            iconName: null,
            iconClass: null,
        },
    ]
</script>
